import { memo } from 'react'
import useI18n from 'src/hooks/use_i18n'
import { filterCarriersName } from 'src/utils/carriers_info'

// #region component
interface Props {
  carriersInfoData?: any
  carriersTargetInfoData?: any
  totalCarriersStr: number | string
  carrierName?: string
  configAnswer?: boolean
}

function WhatDifferent({ carriersInfoData, totalCarriersStr, configAnswer = false, carrierName = '17track' }: Props) {
  const { $t, activeLocale: locale, i18nFormatAll } = useI18n()
  const renderWhatDifferenceAnswer = ({ useConfigAnswer = false }: { useConfigAnswer?: boolean } = {}) => {
    if (useConfigAnswer && carriersInfoData?.commonConfig?.whatDifferenceAnswer?.length) {
      return carriersInfoData.commonConfig.whatDifferenceAnswer.map((item, index) => {
        return (
          <p key={index}>
            {i18nFormatAll(item, {
              carriersNum: totalCarriersStr,
              _routeLang: locale,
              carrierTitle: carrierName
            })}
          </p>
        )
      })
    } else {
      return (
        <>
          <p
            dangerouslySetInnerHTML={{
              __html: i18nFormatAll($t('ResCarrierListPSeoDetails.global.__pWhatDifferent_answerDesc'), {
                carriersNums: totalCarriersStr,
                yqTrackUrl: '17TRACK',
                yqTrackUrlUrl: `https://www.17track.net/${locale}/carriers/${filterCarriersName(carrierName)}`
              })
            }}
          ></p>
          <p
            dangerouslySetInnerHTML={{
              __html: i18nFormatAll(
                `<strong>${$t('ResCarrierListPSeoDetails.global.__pWhatDifferent_answerType1')}</strong>` +
                  $t('ResCarrierListPSeoDetails.global.__pWhatDifferent_answerType1Answer'),
                {
                  carriersNum: totalCarriersStr,
                  yqTrackAppUrl: '17TRACK APP',
                  yqTrackAppUrlUrl: `https://www.17track.net/${locale}/app`
                }
              )
            }}
          ></p>
          <p
            dangerouslySetInnerHTML={{
              __html: i18nFormatAll(
                `<strong>${$t('ResCarrierListPSeoDetails.global.__pWhatDifferent_answerType2')}</strong>` +
                  $t('ResCarrierListPSeoDetails.global.__pWhatDifferent_answerType2Answer'),
                {
                  apiUrl: 'API',
                  apiUrlUrl: `https://www.17track.net/${locale}/api`,
                  shopifyAppUrl: 'Shopify APP',
                  shopifyAppUrlUrl: `https://apps.shopify.com/17track?utm_source=www.17track.net/carriers&utm_medium=link&utm_campaign=${carrierName}`
                }
              )
            }}
          ></p>
          <p>{$t('ResCarrierListPSeoDetails.global.__pWhatDifferent_answerType3')}</p>
        </>
      )
    }
  }

  return (
    <>
      <div itemProp="mainEntity" itemScope itemType="https://schema.org/Question">
        <h2 title="" itemProp="name">
          {carriersInfoData?.commonConfig?.whatDifference ??
            i18nFormatAll($t('ResCarrierListPSeoDetails.global.__pWhatDifferentProblem'), {
              carriersName: carrierName
            })}
        </h2>
        <div itemProp="acceptedAnswer" itemScope itemType="https://schema.org/Answer">
          <div itemProp="text">{renderWhatDifferenceAnswer({ useConfigAnswer: configAnswer })}</div>
        </div>
      </div>
    </>
  )
}

export default memo(WhatDifferent)
